import { userConstants } from './userConstants';
import {userConstants as userAuthConstants} from "../../../auth/_redux/authConstants";

const makeInitialState = () => ({
  requestActive: false,
  requestSaveActive: false,
  shouldReload: true,
  items: [],
  rowsPerPage: 10,
  page: 1,
  sortBy: "id",
  sortDirection: "desc",
  total: 0,
  error: '',
  query: "",
  inProgress: true,
  status: true,
});

export function acl_users(state = makeInitialState(), action) {
  switch (action.type) {
    case userAuthConstants.LOGOUT:
      return makeInitialState();
    case userConstants.ACL_USER_LIST_REQUEST:
      return {
        ...state,
        requestActive: true,
        shouldReload: false,
        error: '',
        total: 0,
        inProgress: true,
      };
    case userConstants.ACL_USER_LIST_SUCCESS:
      return {
        ...state,
        requestActive: false,
        shouldReload: false,
        items: action.users.rows ? action.users.rows : [],
        total: action.users.total ? action.users.total : 0,
        inProgress: false,
      };
    case userConstants.ACL_USER_LIST_FAILURE:
      return {
        ...state,
        error: action.error,
        inProgress: false,
      };
    case userConstants.ACL_USER_LIST_CHANGED:
      return {
        ...state,
        shouldReload: true,
      };
    case userConstants.ACL_USER_LIST_PAGINATION: {
      let shouldReload = state.items.length === 0 ? true : false;

      if (state.rowsPerPage !== action.pagination.rowsPerPage
        || state.page !== action.pagination.page
        || state.sortBy !== action.pagination.sortBy
        || state.sortDirection !== action.pagination.sortDirection
        || state.query !== action.pagination.query
        || state.exactFields !== action.pagination.exactFields
        || state.exactValues !== action.pagination.exactValues
        || state.shouldReload) {
        shouldReload = true;
      }

      return {
        ...state,
        rowsPerPage: action.pagination.rowsPerPage,
        page: action.pagination.page,
        sortBy: action.pagination.sortBy,
        sortDirection: action.pagination.sortDirection,
        query: action.pagination.query,
        exactFields: action.pagination.exactFields,
        exactValues: action.pagination.exactValues,
        shouldReload
      };
    }

    case userConstants.ACL_USER_LIST_STATUS: {
      return {
        ...state,
        status: action.status
      }
    }

    case userConstants.ACL_USER_SAVE_REQUEST:
      return {
        ...state,
        requestSaveActive: true,
      }
    case userConstants.ACL_USER_SAVE_SUCCESS:
      if (action.isNew) {
        return {
          ...state,
          requestSaveActive: false,
          items: [...state.items, action.user],
        }
      }
      return {
        ...state,
        requestSaveActive: false,
        items: state.items.map(t => t.id === action.user.id ? action.user : t)
      }
    case userConstants.ACL_USER_SAVE_FAILURE:
      return {
        ...state,
        requestSaveActive: false,
        error: action.error,
      }

    default:
      return state
  }
}
